import React, { useEffect, useState } from "react";
import { apiMethod } from "../../../api";
import BackupAccountUI from "./BackupAccountUI";

const FacebookLink  = () => {
  const [account, setAccount] = useState(null);
  const [unlinkModal, setUnlinkModal] = useState(null);
  const [unlinkLoading, setUnlinkLoading] = useState(false);

  useEffect(() => {
    getToken().then(getIdentity);
  }, [])

  const getToken = () => {
    return new Promise((resolve, reject) => {
      apiMethod("social_assign", {
        type: "fb"
      }, response => {
        if (response.access_token) {
          Facebook.token = response.access_token;
          resolve(response);
        }
      }, {
        errorCallback: (error) => { console.error(error) }
      })
    })

  }

  const getIdentity = (response) => {
    Facebook.name = response.name;
    Facebook.expire = response.expire;
    setAccount(response.name);
  }

  const onLink = () => {
    Facebook.getTokenCallback((token, expire) => {
      HFN.message('Token saved.');
      getIdentity();
    });
  };

  const onUnlink = () => {
    apiMethod('social_assign', { type: 'fb', dismiss: 'true' }, ret => {
      HFN.message(__('Account unlinked.'));
      Facebook.token = null;
      setAccount(null);
    })
  }

  return (
    <BackupAccountUI
      type="fb"
      app={__("Facebook Account")}
      account={account}
      linked={!!account}
      onLink={onLink}
      onUnlink={onUnlink}
    />
  )
}

export default FacebookLink ;